import {
  type CarListApiData,
  type UserGroupFleetViewCarsListApiData,
  WheelLockHardwareManufacturer,
  WheelLockHardwareManufacturerLabels
} from '@navio/nsdk';
import { filterUnitFor, type SharedQuery } from 'noddi-ui-web';
import { entriesToOptions } from 'noddi-util';

type CarQuery = NonNullable<CarListApiData['query']>;
type FleetQuery = NonNullable<UserGroupFleetViewCarsListApiData['query']>;
const unit = filterUnitFor<SharedQuery<CarQuery, FleetQuery>>();

const manufacturerOptions = entriesToOptions(WheelLockHardwareManufacturer, WheelLockHardwareManufacturerLabels);

export const wheelLockFilters = [
  unit.boolean('hasWheelLock', {
    title: 'Has wheel lock',
    description: 'A lock is recorded on a wheel, or an active setup says one is fitted.'
  }),
  unit.multiSelect('wheelLockManufacturers', {
    title: 'Wheel lock manufacturer',
    description: 'Cars whose active setup names one of these makers.',
    options: manufacturerOptions,
    exclude: true
  })
];
